/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSuggestedActionsRequest} from '@cash-web/protos/squareup/cash/cashfrontdoor/api/v1beta1/suggested_actions_messages.pb'
import {GetSuggestedActionsResponse} from '@cash-web/protos/squareup/cash/cashfrontdoor/api/v1beta1/suggested_actions_messages.pb'


export const getSuggestedActions = (request: GetSuggestedActionsRequest, options?: CashRequestOptions) => post<GetSuggestedActionsRequest, GetSuggestedActionsResponse>("/cash-app/frontdoor/get-suggested-actions", request, {...options, rejectOnError: true })